import React from "react";

import Banner from "../../../sections/Banner/Banner";
// import ContentBlock from "../../../sections/ContentBlock/ContentBlock";

import meets from "./meets.json";
import "./Schedule.css";

const schedule = () => {
  return (
    <div className="Schedule">
      <Banner
        img_src="https://districttrack.s3.us-east-2.amazonaws.com/v2/photos/running/women-legs.jpg"
        img_alt="Women's Team Legs"
      >
        <h1>Race Schedule</h1>
      </Banner>
      <section className="meetSchedule">
        <div className="spacer"></div>
        <h4>Indoor Season</h4>
        <div className="spacer"></div>
        <div className="meetHeader">
          <div></div>
          <div className="meetName">Event</div>
          <div className="meetDate">Date</div>
          <div className="meetLocation">Location</div>
          <div className="meetDetails">Details</div>
        </div>

        {meets["indoor"].map((meet) => (
          <div className="meet">
            <div className="meetImg">
              <img src={meet["img"]} alt={meet["name"]} />
            </div>

            <h4 className="meetName">{meet["name"]}</h4>
            <div className="meetDate">{meet["date"]}</div>
            <div className="meetLocation">
              {meet["venue"]}
              <br />
              {meet["city"]}
            </div>
            <div className="meetDetails">
              <ul>
                {meet["details"].map((detail) => (
                  <li>
                    <a href={detail["link"]}>{detail["text"]}</a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        ))}

        {/* ***** OUTDOOR SEASON ***** */}
        <div className="spacer"></div>
        <div className="spacer"></div>
        <h4>Outdoor Season</h4>
        <div className="spacer"></div>
        <div className="meetHeader">
          <div></div>
          <div className="meetName">Event</div>
          <div className="meetDate">Date</div>
          <div className="meetLocation">Location</div>
          <div className="meetDetails">Details</div>
        </div>

        {meets["outdoor"].map((meet) => (
          <div className="meet">
            <div className="meetImg">
              <img src={meet["img"]} alt={meet["name"]} />
            </div>

            <h4 className="meetName">{meet["name"]}</h4>
            <div className="meetDate">{meet["date"]}</div>
            <div className="meetLocation">
              {meet["venue"]}
              <br />
              {meet["city"]}
            </div>
            <div className="meetDetails">
              <ul>
                {meet["details"].map((detail) => (
                  <li>
                    <a href={detail["link"]}>{detail["text"]}</a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        ))}

        <p className="disclaimer">
          *Due to COVID-19, this schedule is subject to change as coaches and
          meet directors monitor health risks and recommendations by the CDC.
        </p>
      </section>
    </div>
  );
};

export default schedule;
